import { PageLocatorMap } from '../types/PageLocatorMap';

export const mailCodePinVerifyPage = {
  alert: {
    error: 'mail-code-pin-verify-page.alert.error',
    success: 'mail-code-pin-verify-page.alert.success',
  },
  footer: {
    root: 'mail-code-pin-verify-page.footer.root',
  },
  form: {
    h1: 'mail-code-pin-verify-page.form.heading1',
    h3: 'mail-code-pin-verify-page.form.heading3',
    pinInput1: 'mail-code-pin-verify-page.form.pin-input-1',
    pinInput2: 'mail-code-pin-verify-page.form.pin-input-2',
    pinInput3: 'mail-code-pin-verify-page.form.pin-input-3',
    pinInput4: 'mail-code-pin-verify-page.form.pin-input-4',
    pinInput5: 'mail-code-pin-verify-page.form.pin-input-5',
    pinInput6: 'mail-code-pin-verify-page.form.pin-input-6',
    pinInputError: 'mail-code-pin-verify-page.form.pin-error',
    resendPinLink: 'mail-code-pin-verify-page.form.resend-pin-link',
    root: 'mail-code-pin-verify-page.form.root',
  },
} as const satisfies PageLocatorMap;
